import Vue from 'vue';
import Vuex from 'vuex';
import { auth } from "./auth.module";
import { financialRelease } from "./financialRelease.module";
Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    auth: auth,
    financialRelease: financialRelease
  }
});